import React from 'react';
import styles from './MapNavigationPopup.module.css';

interface MapNavigationPopupProps {
  currentMapName: string;
  maps: string[];
  processedMapNames: string[];
  onMapChange: (mapName: string) => void;
  onClose: () => void;
}

const MapNavigationPopup: React.FC<MapNavigationPopupProps> = ({
  currentMapName,
  maps,
  processedMapNames,
  onMapChange,
  onClose,
}) => {
  const isMapProcessed = (mapName: string) => {
    return processedMapNames.includes(mapName);
  };

  const handleMapClick = (mapName: string) => {
    if (isMapProcessed(mapName)) {
      onMapChange(mapName);
      onClose();
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <h4>Select Map</h4>
        <div className={styles.mapGrid}>
          {maps.map((mapName) => {
            const isProcessed = isMapProcessed(mapName);
            return (
              <button
                key={mapName}
                className={`${styles.mapButton} ${
                  mapName === currentMapName ? styles.active : ''
                } ${!isProcessed ? styles.disabled : ''}`}
                onClick={() => handleMapClick(mapName)}
                disabled={!isProcessed}
              >
                {mapName}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MapNavigationPopup;
